import { DiscoveryStatusJson } from './dto';

const discoveryStatusExample: DiscoveryStatusJson = {
	status: 'no_agent',
};

export { discoveryStatusExample };
